import styled from '@emotion/styled';

export const Container = styled.div`
  width: 100%;
`;
export const Inner = styled.div`
  padding: 60px 16px 40px;
  border-radius: 24px;
  border: 1px solid transparent;
  background:
    linear-gradient(white, white) padding-box,
    linear-gradient(to right, #3449ff, #f86b3e) border-box;
`;
export const Title = styled.h2`
  color: #111827;
  font-size: 24px;
  font-weight: 700;
  line-height: 34px;
  letter-spacing: -0.487px;
`;
export const SubTitle = styled.h3`
  color: #121212;
  font-size: 16px;
  font-weight: 500;
  line-height: 28px;
`;
export const Price = styled.p`
  padding: 28px 0 18px;
  color: #121212;
  font-size: 16px;
  font-weight: 500;
  line-height: 21px;
  letter-spacing: -0.48px;
  border-bottom: 1px solid #e5e7eb;
`;
export const Month = styled.span`
  color: #121212;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  letter-spacing: -0.42px;
`;
export const SolutionList = styled.ul`
  padding-top: 28px;
  border-top: 1px solid #e5e7eb;
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
export const Solution = styled.li`
  position: relative;
  padding-left: 20px;
  color: #121212;
  font-size: 16px;
  font-weight: 500;
  line-height: 21px;
  letter-spacing: -0.64px;

  &::before {
    content: '•';
    position: absolute;
    top: 0;
    left: 8px;
    width: 4px;
    height: 4px;
  }
`;
export const SolutionEmphasis = styled.em`
  color: #3449ff;
  font-style: normal;
  font-weight: inherit;
`;
export const ExtraInfo = styled.span`
  color: #727272;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  letter-spacing: -0.42px;
`;
